import { CODE_CHUNK_LENGTH } from './consts';

const HYPHENLESS_CODE_LENGTH = CODE_CHUNK_LENGTH * 2;

/**
 * Normalizes a device code to the backend's stored shape: uppercase `XXXX-XXXX`.
 * Accepts the hyphen-less `XXXXXXXX` form and inserts the hyphen between the two chunks.
 * @param code - Raw user input (already trimmed by the form schema).
 * @returns The uppercased, hyphenated code.
 */
export const normalizeDeviceCode = (code: string): string => {
  const upper = code.trim().toUpperCase();

  if (upper.length !== HYPHENLESS_CODE_LENGTH || upper.includes('-')) {
    return upper;
  }

  return `${upper.slice(0, CODE_CHUNK_LENGTH)}-${upper.slice(
    CODE_CHUNK_LENGTH,
  )}`;
};
